// AuthContext.js
import React, { useContext, useState, useEffect, createContext } from "react";
import { auth, firestore, db } from "../firebase";
import {
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
  updateProfile
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { ref, set, serverTimestamp } from "firebase/database";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  async function signup(email, password, name, phone) {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(result.user, { displayName: name });
    await setDoc(doc(firestore, "users", result.user.uid), {
      name: name,
      email: email,
      phone: phone
    });
    await set(ref(db, "users/" + result.user.uid), {
      Data: {
        progress: "00000000000000000000",
        ss: {
          STUDY0: "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000"
        }
      },
      coin: 0,
      email: email,                   // 이메일은 가입 정보로 넣기
      expiryStat: 0,
      group: "00000",
      level: 0,
      loginCnt: 0,
      loginTime: 0,
      name: name,                     // 이름도 가입 정보로 넣기
      pay: false,
      phone: phone,
      startAt: serverTimestamp(),     // 시작 시간 (필요하면 자동 생성 가능)
      startAtdays: 0,                 // 시작일수
      startAtend: serverTimestamp(),  // 종료 시간
      team: "000",
      usertype: "0"
    });
    return result;
  }

  async function login(email, password) {
    await setPersistence(auth, browserSessionPersistence);
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    localStorage.removeItem("user");
    sessionStorage.removeItem("user");
    document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    return signOut(auth);
  }

  async function getUserData(uid) {
    const userDoc = await getDoc(doc(firestore, "users", uid));
    return userDoc.exists() ? userDoc.data() : null;
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userData = await getUserData(user.uid);
        setCurrentUser({ ...user, ...userData });
      } else {
        setCurrentUser(null);
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logout,
    getUserData,
  };

  return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
}